export default "__VITE_ASSET__Dw8m0ZiW__"